import { useEffect, useRef, useState } from "react";

export const PAGE_SIZES = [10, 25, 50, 75, 100];
const PAGE_SIZE_SET = new Set(PAGE_SIZES);
const DEFAULT_PAGINATION = { pageIndex: 0, pageSize: 10 };

function storageKey(key) {
  return `pagination:${key}`;
}

export function readPagination(key, defaults = { pageIndex: 0, pageSize: 10 }) {
  if (!key) return defaults;
  try {
    const raw = sessionStorage.getItem(storageKey(key));
    if (!raw) return defaults;
    const parsed = JSON.parse(raw);
    const pageSize = PAGE_SIZE_SET.has(parsed.pageSize) ? parsed.pageSize : defaults.pageSize;
    const pageIndex =
      Number.isInteger(parsed.pageIndex) && parsed.pageIndex >= 0
        ? parsed.pageIndex
        : defaults.pageIndex;
    return { pageIndex, pageSize };
  } catch {
    return defaults;
  }
}

function writePagination(key, value) {
  if (!key) return;
  try {
    sessionStorage.setItem(storageKey(key), JSON.stringify(value));
  } catch {
    // sessionStorage can be unavailable; pagination still works for this visit.
  }
}


export function usePersistedPagination(key, defaults = DEFAULT_PAGINATION) {
  const defaultsRef = useRef(defaults);
  defaultsRef.current = defaults;
  const [pagination, setPagination] = useState(() => readPagination(key, defaults));
  const keyRef = useRef(key);

  useEffect(() => {
    if (keyRef.current !== key) {
      keyRef.current = key;
      setPagination(readPagination(key, defaultsRef.current));
      return;
    }
    writePagination(key, pagination);
  }, [key, pagination]);

  return [pagination, setPagination];
}
